<template>
    <v-container fluid class="ma-1 pa-2">
        <search-toolbar :title="$t('message.150')" :filter-enabled="false"></search-toolbar>
        <autocomplete ref="autocomplete" v-model="autocomplete" :placeholder="$t('message.214')" index="part"></autocomplete>
        <results-widget ref="results" index="part" :link-to-parts="false"></results-widget>
    </v-container>
</template>

<script>

export default {
  name: 'parts',
  data () {
    return {
      loading: false,
      autocomplete: null,
      items: []
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      let query = vm.$route.query
      if ((query) && (query.part)) {
        vm.$refs.autocomplete.preselect(query.part)
      }
    })
  },
  watch: {
    autocomplete (value) {
      if (value === null) {
        this.$router.replace(this.$route.path)
      }
      this.$refs.results.search(value)
    }
  }
}
</script>

<style scoped>

</style>
